import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/home'
import Introduce from '@/pages/introduce/introduce'
import Production from '@/pages/production/production'
import ProductDetail from '@/pages/production/detail'
import News from '@/pages/news/news'
import NewsDetail from '@/pages/news/detail'
import Notice from '@/pages/notice/notice'
import NoticeDetail from '@/pages/notice/detail'
import Culture from '@/pages/culture/culture'
import CultureDetail from '@/pages/culture/detail'
import Consult from '@/pages/consult/consult'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
  //mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/introduce',
      name: 'Introduce',
      component: Introduce
    },
    {
      path: '/production',
      name: 'Production',
      component: Production
    },
    {
      path: "/production/detail",
      name: "ProductDetail",
      component: ProductDetail
    },
    {
      path: '/news',
      name: 'News',
      component: News
    },
    {
      path: "/news/detail",
      name: "NewsDetail",
      component: NewsDetail
    },
    {
      path: '/notice',
      name: 'Notice',
      component: Notice
    },
    {
      path: "/notice/detail",
      name: "NoticeDetail",
      component: NoticeDetail
    },
    {
      path: '/culture',
      name: 'Culture',
      component: Culture
    },
    {
      path: "/culture/detail",
      name: "CultureDetail",
      component: CultureDetail
    },
    {
      path: '/consult',
      name: 'Consult',
      component: Consult
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js